import type { LinkedinTier } from "@/utils/getLinkedinTier";

import type { SenderRecipientOption } from "../components/SenderRecipientDropdown";

/**
 * Resolves the LinkedIn tier of a draft's sender by matching its `userId` against
 * the LinkedIn sender options (which carry the tier computed in `buildSenderOptions`).
 * Falls back to "free" — the most restrictive tier — when no match is found.
 */
export const resolveSenderTier = (
	userId: number | undefined,
	options: SenderRecipientOption[]
): LinkedinTier =>
	options.find((o) => o.type === "linkedin" && o.userId === userId)?.linkedinTier ?? "free";
